import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import WalletButton, { WalletButtonProps } from './wallet_button';
import get from '../../../../../helpers/data_layer/get';
import { getPaymentProvider } from '../../helpers';

const stripeConfig = getPaymentProvider(
  get('commerce.payment_providers'),
  'stripe',
);

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  stripeConfig && stripeConfig.publishable_key
    ? stripeConfig.publishable_key
    : '',
);

export function StripeCheckoutWallet(props: WalletButtonProps) {
  return (
    <>
      <Elements stripe={stripePromise}>
        <WalletButton {...props} />
      </Elements>
    </>
  );
}

export default StripeCheckoutWallet;
